import React, { useState, useEffect } from 'react';
import { Card, Badge, Button } from 'react-bootstrap';
import { Calendar, Bell, ChevronRight, Info, AlertOctagon } from 'lucide-react';
import axiosInstance from '../../api/axiosConfig';

const AnnouncementTimeline = () => {
    const [notices, setNotices] = useState([]);

    useEffect(() => {
        const fetchNotices = async () => {
            try {
                const res = await axiosInstance.get('/announcements');
                setNotices(res.data.data);
            } catch (err) {
                console.error("Timeline Error:", err);
            }
        };
        fetchNotices();
    }, []);

    const getPriorityStyle = (priority) => {
        switch (priority) {
            case 'critical': return { border: 'border-danger', icon: <AlertOctagon className="text-danger" />, bg: 'bg-danger' };
            case 'high': return { border: 'border-warning', icon: <Info className="text-warning" />, bg: 'bg-warning' };
            default: return { border: 'border-primary', icon: <Bell className="text-primary" />, bg: 'bg-primary' };
        }
    };

    return (
        <div className="announcement-timeline">
            <h5 className="fw-bold mb-4">Company Updates</h5>
            {notices.length > 0 ? (
                notices.map((notice, index) => {
                    const style = getPriorityStyle(notice.priority);
                    return (
                        <div key={notice.id} className="d-flex mb-4 gap-3">
                            <div className="timeline-connector d-flex flex-column align-items-center">
                                <div className={`rounded-circle p-2 ${style.bg} text-white shadow-sm`}>
                                    <Calendar size={16} />
                                </div>
                                {index !== notices.length - 1 && <div className="line bg-light flex-grow-1" style={{ width: '2px' }}></div>}
                            </div>
                            <Card className={`border-0 border-start border-4 shadow-sm ${style.border} flex-grow-1`}>
                                <Card.Body className="p-3">
                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                        <h6 className="fw-bold mb-0">{notice.title}</h6>
                                        <Badge bg={notice.priority === 'critical' ? 'danger' : 'light'} className="text-dark small">
                                            {new Date(notice.created_at).toLocaleDateString()}
                                        </Badge>
                                    </div>
                                    <p className="text-muted small mb-2">{notice.message}</p>
                                    <Button variant="link" className="p-0 text-decoration-none small d-flex align-items-center">
                                        View Details <ChevronRight size={14} />
                                    </Button>
                                </Card.Body>
                            </Card>
                        </div>
                    );
                })
            ) : (
                <p className="text-muted">No recent announcements.</p>
            )}
        </div>
    );
};

export default AnnouncementTimeline;